export default __webpack_public_path__ + "static/media/icon8.f4aed76a.svg";